export default __webpack_public_path__ + "static/media/Design_Onboarding.ea162dd0.png";